import { render, staticRenderFns } from "./ToothNumberDialog.vue?vue&type=template&id=9f6d7754&scoped=true&"
import script from "./ToothNumberDialog.vue?vue&type=script&lang=js&"
export * from "./ToothNumberDialog.vue?vue&type=script&lang=js&"
import style0 from "./ToothNumberDialog.vue?vue&type=style&index=0&id=9f6d7754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6d7754",
  null
  
)

export default component.exports